import { DataLakeEventDispatcher as DataLayerDispatcher, EventType } from "@studyportals/datalayer";
export class TrackerImporter {
    trackerObject;
    trackerIsLoaded;
    dataLayerTrackerObject;
    constructor() {
        this.trackerObject = null;
        this.dataLayerTrackerObject = null;
        this.trackerIsLoaded = false;
    }
    get tracker() {
        return this.trackerObject;
    }
    get dataLayerTracker() {
        return this.dataLayerTrackerObject;
    }
    get trackerLoaded() {
        return this.trackerIsLoaded;
    }
    loadTracker(callback) {
        if (typeof window['dataLayer'] !== 'undefined') {
            this.dataLayerTrackerObject = new DataLayerDispatcher();
            callback(this.dataLayerTrackerObject);
            return;
        }
        document.addEventListener(EventType.DATA_LAYER_INITIALISED, () => {
            this.dataLayerTrackerObject = new DataLayerDispatcher();
            callback(this.dataLayerTrackerObject);
        });
    }
}
